import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../@core/auth/jwt/jwtService";
const axios = require("axios");

const url = process.env.REACT_APP_URI;
const companyId = process.env.REACT_APP_COMPANY_ID;

export const getEvents = createAsyncThunk(
  "users/getEvents",
  async (searchQuery, thunkAPI) => {
    const response = await axiosInstance.request({
      url: `companies/${companyId}/events`,
      method: "get",
      params: {
        searchQuery,
      },
    });
    return { data: response.data };
  }
);

export const getEventsByUser = createAsyncThunk(
  "users/getEventsByUser",
  async (id, thunkAPI) => {
    const response = await axiosInstance.request({
      url: `companies/${companyId}/events/users/${id}`,
      method: "get",
    });
    return { data: response.data };
  }
);

export const getUsers = createAsyncThunk("users/getUsers", async (args) => {
  const { pageSize, pageNumber, searchQuery } = args;
  const response = await axiosInstance.request({
    url: `/users`,
    method: "get",
    params: {
      pageSize,
      pageNumber,
      searchQuery,
    },
  });
  return { data: response };
});

export const getUserById = createAsyncThunk(
  "users/getUserById",
  async (id, thunkAPI) => {
    const response = await axiosInstance.request({
      url: `/users/${id}`,
      method: "get",
    });
    return { data: response.data };
  }
);

export const getRoles = createAsyncThunk(
  "users/getRoles",
  async (inputValue, thunkAPI) => {
    try {
      const response = await axiosInstance.request({
        url: `/roles?searchQuery=${inputValue}`,
        method: "get",
      });

      return { data: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los roles. Error: ",
        error
      );
    }
  }
);

export const setUser = async (data) => {
  await axiosInstance.post(`/users`, data);
};

export const updateUser = async (id) => {
  await axiosInstance.put(`/users/${id}`);
};

export const updateUserEvents = async (id, data) => {
  await axiosInstance.patch(`/users/${id}`, data);
};

export const userSlice = createSlice({
  name: "users",
  initialState: {
    user: [],
    users: [],
    events: [],
    totalRows: 0,
    usersRoles: [],
    arrayRoles: [],
    usersEvents: [],
    inputSearch: "",
    statusUsers: false,
    pendingById: false,
    userEventsLoader: false,
  },
  reducers: {
    setEventList: (state, action) => {
      state.eventsArray = action.payload;
    },
    clearListEvents: (state, action) => {
      state.events = action.payload;
    },
    setArrayRoles: (state, action) => {
      state.arrayRoles = action.payload;
    },
    clearUser: (state, action) => {
      state.user = [];
    },
    setInputSearch: (state, action) => {
      state.inputSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEvents.fulfilled, (state, action) => {
        state.events = action.payload.data;
        state.userEventsLoader = false;
      })
      .addCase(getEvents.pending, (state, action) => {
        state.userEventsLoader = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.users = data;
        state.statusUsers = false;
        state.totalRows = JSON.parse(data?.headers["x-pagination"]).totalCount;
      })
      .addCase(getUsers.pending, (state, action) => {
        state.statusUsers = true;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.pendingById = false;
        state.user = data;
        data?.roles?.forEach((element) => {
          state.usersRoles.push({
            id: element.id,
            name: element.name,
            isChecked: true,
          });
        });
      })
      .addCase(getUserById.pending, (state, action) => {
        state.pendingById = true;
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.pendingById = false;
      })
      .addCase(getEventsByUser.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.usersEvents = data;
      })
      .addCase(getEventsByUser.pending, (state, action) => {});
  },
});

export const { clearUser, setArrayRoles, setInputSearch, clearListEvents } =
  userSlice.actions;

export default userSlice.reducer;
